import { Component, OnInit, OnChanges, SimpleChange, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subscription, Subject } from 'rxjs/';

import { NotificationService } from 'app/core/services/notification.service';
import { ConfigService } from 'app/core/services/config.service';

import { AddressCommonService } from '../services/address-common.service';
import { AddressDetails } from './address-details.model';
import { UtilService } from 'app/core/services/util.service';

declare var $:any;

@Component({
	selector: 'itpx-address-form-component',
	templateUrl: './address-form-component.component.html',
	styleUrls: ['./address-form-component.component.css']
})
export class AddressFormComponentComponent implements OnInit {

	@Input() data: any;
    @Input() isEdit: boolean;
    @Input() isEditBillingAddress: boolean;
	@Output() isCancel = new Subject();
    @Output() isSaved = new Subject();
    @Output() emitFormHeight = new Subject();
    @ViewChild('formComponent') formComponent: ElementRef;

	private details: AddressDetails = new AddressDetails();
    private countries: any = [];
    private domains: any = [];
    private codeCountryList: any = {};
    private patternList: any = {};
    private pattern: string = '.+';
    private countryCode: string;
    private states: any = [];
    private showStates: boolean = false;
    private isInProgress: boolean = false;

	constructor(
		private service: AddressCommonService,
        private configService: ConfigService,
        private notificationService: NotificationService,
        private router: Router,
        private utilService: UtilService
	) { }

	ngOnInit() {
		let domain;
		if(this.data) {
			this.details = this.data;

			if(this.details.domains) {
				domain = this.details.domains[0].name
			} else if(this.details.domain) {
				domain = this.details.domain
			}

			if(this.details['isDefaultBillingAddress']) {
			    this.isEditBillingAddress = true;
            }
		}


        this.service.getCountries()
            .subscribe(
                body => this.countries = this.formatDict(body.data).reverse(),
            );
        this.service.getPatternCodeList()
            .subscribe(
                body => this.patternList = body.data,
            );
        this.service.getDomains()
            .subscribe(
                body => this.domains = body.data,
            );

        this.details.primaryAddress = false;
        if(this.isEdit) {
            this.updateStates();
        }
    }

    ngAfterViewInit() {
        this.getFormHeight();
    }

    private getFormHeight(){
        this.emitFormHeight.next($(this.formComponent.nativeElement).outerHeight() + 50);
    }

	private onCancel() {
		this.isCancel.next(true);
	}

    private save() {
		if(this.isEdit) {
			this.service.edit(this.details)
            .subscribe(
                body => {
                    this.notificationService.success('Successfully edited billing address',  'Success');
					this.isSaved.next(true);
				}
            );
		} else {
			this.service.add(this.details)
				.subscribe(
					body => {
						this.notificationService.success('Successfully added shipping address',  'Success');
						this.isSaved.next(true);
					}
				);
		}

    }

    private onPhoneNumbersChange(phoneNumbers: any[]) {
        this.details.phoneNumbers = phoneNumbers;
        this.getFormHeight();
    }

    private formatDict(obj: any) {
        this.codeCountryList = obj;
        let result = [];
        for (let prop in obj) {
            if(obj.hasOwnProperty(prop)) {
                result.push({key: prop, value: obj[prop]});
            }
        }
        return result;
    }
    private getPatternByCountry(country): string {
        for (let prop in this.codeCountryList) {
            if (this.codeCountryList.hasOwnProperty(prop)) {
                if (prop.indexOf(country) !== -1) {
                    return this.getPatternByCode(prop);
                }
            }
        }
    }
    private getPatternByCode(code): string {
        for (let obj in this.patternList) {
            if (this.patternList[obj]['key'] == code) {
                return this.patternList[obj]['pattern'];
            }
        }
    }

    private onChangeCountry(event) {
        if(event) {
            this.details.country = event;
            this.details.zipCode = undefined;
            this.pattern = this.getPatternByCountry(event);
            this.updateStates();
        }
    }

    private updateStates() {
        this.showStates = false;
        if(this.details.country) {
            this.service.getStatesByCountry(this.details.country)
                .subscribe(
                    body => {
                        this.states = body.data;
                        if(this.states.length)
                            this.showStates = true;
                    },
                    err => {
                        this.states = [];
                    }
                );
        } else {
            this.states = [];
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/organization/components/common/address-form-component/address-form-component.component.ts